/**
 *
 * AllEventsItem
 *
 */

import React, { memo, FunctionComponent } from 'react';
import { StyledAllEventsItem, StyledDateTab } from './styledComponents';
import { StyledCard, StyledEventImage } from '../../../../global-styles';
import Badge from '../../../../components/Badge/Badge.component';
import calendarIcon from '../../../../assets/icons/calendar-accent.svg';
import liveIcon from '../../../../assets/icons/live.svg';
import enterIcon from '../../../../assets/icons/enter.svg';
import awardIcon from '../../../../assets/icons/award-accent.svg';
import useResizeObserver from 'use-resize-observer';
import { LiveFeedEvent } from '../../../../domain';
import { Link } from 'react-router-dom';
import useChangeLocationSearch from '../../../../hooks/useChangeLocationSearch';

interface IProps {
  item: LiveFeedEvent;
  showItemGroup: boolean;
  active: boolean;
}

const AllEventsItem: FunctionComponent<IProps> = ({
  item,
  showItemGroup,
  active,
}) => {
  const { ref, width = 1001 } = useResizeObserver();

  const getModifiedSearchQuery = useChangeLocationSearch();

  if (width > 1000) {
    return (
      <>
        {showItemGroup && (
          <StyledDateTab className="txt fw-7">
            {item.eventDateGroup}
          </StyledDateTab>
        )}
        <StyledAllEventsItem ref={ref}>
          <StyledCard className={active ? 'active' : ''}>
            <div className="card-body">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="mr-24">
                    <StyledEventImage>
                      <img src={item.logoUrl} alt="" />
                    </StyledEventImage>
                  </div>
                  <div className="d-flex mr-24 event-name-cell">
                    <Link
                      to={{
                        pathname: '/feed',
                        search: getModifiedSearchQuery([
                          { param: 'e', value: item.eventId.toString() },
                          { param: 'c', value: undefined },
                        ]),
                      }}
                      className="txt fw-7 txt-accent"
                    >
                      {item.eventName}
                    </Link>
                  </div>
                  <div className="d-flex flex-column mr-24 event-date-cell ">
                    <div className="txt fw-7">{item.eventDate}</div>
                    <div className="txt txt-secondary fs-11">Event Date</div>
                  </div>
                  <div className="d-flex flex-column mr-24">
                    {item.status === 'Results Available' ? (
                      <div className="txt fw-7 txt-accent mr-9">
                        Results Available <img src={awardIcon} alt="" />
                      </div>
                    ) : (
                      <div className="txt fw-7 mr-9">{item.status}</div>
                    )}
                    <div className="txt txt-secondary fs-11">Status</div>
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <a
                    href={`https://myridinglife.com/eventdetails.aspx?id=${item.eventId}`}
                    className="mr-10"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Badge
                      className="grey-accent"
                      icon={<img src={calendarIcon} alt="" />}
                    >
                      Schedule
                    </Badge>
                  </a>
                  <Link
                    to={{
                      pathname: '/feed',
                      search: getModifiedSearchQuery([
                        { param: 'e', value: item.eventId.toString() },
                        { param: 'c', value: undefined },
                      ]),
                    }}
                    className="mr-10"
                  >
                    <Badge
                      className="grey-accent"
                      icon={<img src={liveIcon} alt="" />}
                    >
                      Live Feed
                    </Badge>
                  </Link>

                  {item.isOnlineEntry && (
                    <a
                      href={`https://myridinglife.com/smartlogin.aspx?s=${item.eventId}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Badge
                        accent
                        active
                        icon={<img src={enterIcon} alt="" />}
                      >
                        Enter
                      </Badge>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </StyledCard>
        </StyledAllEventsItem>
      </>
    );
  }
  return (
    <>
      {showItemGroup && (
        <StyledDateTab className="txt fw-7">
          {item.eventDateGroup}
        </StyledDateTab>
      )}
      <StyledAllEventsItem ref={ref}>
        <StyledCard className={active ? 'active' : ''}>
          <div className="card-body">
            <div className="d-flex align-items-center justify-content-between card-head">
              <StyledEventImage className="mb-20">
                <img src={item.logoUrl} alt="" />
              </StyledEventImage>
              <div className="d-flex align-items-center mb-20">
                <a
                  href={`https://myridinglife.com/eventdetails.aspx?id=${item.eventId}`}
                  target="_blank"
                  rel="noreferrer"
                  className="mr-10"
                >
                  <Badge
                    className="grey-accent"
                    icon={<img src={calendarIcon} alt="" />}
                  >
                    Schedule
                  </Badge>
                </a>
                <Link
                  to={{
                    pathname: '/feed',
                    search: getModifiedSearchQuery([
                      { param: 'e', value: item.eventId.toString() },
                      { param: 'c', value: undefined },
                    ]),
                  }}
                  className="mr-10"
                >
                  <Badge
                    className="grey-accent"
                    icon={<img src={liveIcon} alt="" />}
                  >
                    Live Feed
                  </Badge>
                </Link>
                {item.isOnlineEntry && (
                  <a
                    href={`https://myridinglife.com/smartlogin.aspx?s=${item.eventId}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <Badge accent active icon={<img src={enterIcon} alt="" />}>
                      Enter
                    </Badge>
                  </a>
                )}
              </div>
            </div>
            <Link
              to={{
                pathname: '/feed',
                search: getModifiedSearchQuery([
                  { param: 'e', value: item.eventId.toString() },
                  { param: 'c', value: undefined },
                ]),
              }}
              className="txt fw-7 txt-accent mb-20 d-block"
            >
              {item.eventName}
            </Link>

            <div className="d-flex align-items-end justify-content-between">
              <div>
                {item.status === 'Results Available' ? (
                  <div className="txt fw-7 txt-accent mr-9">
                    Results Available <img src={awardIcon} alt="" />
                  </div>
                ) : (
                  <div className="txt fw-7 mr-9">{item.status}</div>
                )}
                <div className="txt txt-secondary fs-11">Status</div>
              </div>
              <div className="text-right">
                <div className="d-flex flex-column">
                  <div className="txt fw-7">{item.eventDate}</div>
                  <div className="txt txt-secondary fs-11">Event Date</div>
                </div>
              </div>
            </div>
          </div>
        </StyledCard>
      </StyledAllEventsItem>
    </>
  );
};

export default memo(AllEventsItem);
